import {COVERGO_SAAS_GAMMA } from "../consts.js"

export const atlas_gamma = {
	"atlas-studio.gamma.covergo.cloud": {
		appConfig: {
			tenantId: "atlas_gamma",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_GAMMA
	}
}


